var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "factors-viz-container",
      class: {
        "factors-viz-container--network":
          _vm.useFactorBaseRevealData && _vm.dataVizTab === "network",
        "factors-viz-container--factor-data":
          _vm.useFactorBaseRevealData && _vm.heatmapPairCount,
      },
      style: _vm.containerStyle,
    },
    [
      _vm.error
        ? _c("div", { staticClass: "error-alert" }, [
            _vm._v(" " + _vm._s(_vm.error) + " "),
          ])
        : _vm._e(),
      _vm.useFactorBaseRevealData &&
      _vm.heatmapPairCount &&
      _vm.cellColorMode !== "factorValue" &&
      _vm.showGroupByControls
        ? _c(
            "div",
            {
              staticClass:
                "mb-2 d-flex flex-nowrap align-items-center overflow-auto fbr-heatmap-toolbar",
            },
            [
              _c(
                "div",
                { staticClass: "fbr-heatmap-control-group" },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "mb-0 font-weight-bold small text-secondary fbr-heatmap-toolbar-label",
                      attrs: { for: "fbr-heatmap-group-mode-select" },
                    },
                    [_vm._v("Group by:")]
                  ),
                  _c("b-form-select", {
                    staticClass: "form-control form-control-sm",
                    staticStyle: { "max-width": "200px" },
                    attrs: {
                      id: "fbr-heatmap-group-mode-select",
                      options: _vm.heatmapGroupModeOptions,
                      size: "sm",
                    },
                    model: {
                      value: _vm.heatmapGroupMode,
                      callback: function ($$v) {
                        _vm.heatmapGroupMode = $$v
                      },
                      expression: "heatmapGroupMode",
                    },
                  }),
                ],
                1
              ),
              _vm.heatmapGroupMode !== "all" && _vm.heatmapGroupOptions.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "fbr-heatmap-control-group fbr-heatmap-group-by-subcontrols",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "mb-0 font-weight-bold small text-secondary fbr-heatmap-toolbar-label",
                          attrs: { for: "fbr-heatmap-group-select" },
                        },
                        [_vm._v(_vm._s(_vm.heatmapGroupSelectLabel) + ":")]
                      ),
                      _c("b-form-select", {
                        staticClass: "form-control form-control-sm",
                        staticStyle: { "max-width": "420px" },
                        attrs: {
                          id: "fbr-heatmap-group-select",
                          options: _vm.heatmapGroupOptions,
                          size: "sm",
                        },
                        model: {
                          value: _vm.selectedHeatmapGroup,
                          callback: function ($$v) {
                            _vm.selectedHeatmapGroup = $$v
                          },
                          expression: "selectedHeatmapGroup",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          class:
            _vm.useFactorBaseRevealData && _vm.heatmapPairCount
              ? "fbr-data-viz-ledger mb-2"
              : "",
        },
        [
          _vm.useFactorBaseRevealData && _vm.heatmapPairCount
            ? _c("div", { staticClass: "fbr-data-viz-toolbar" }, [
                _c(
                  "div",
                  {
                    staticClass: "fbr-data-viz-tabs",
                    attrs: {
                      role: "tablist",
                      "aria-label": "Data visualization",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "fbr-data-viz-tab",
                        class: { "is-active": _vm.dataVizTab === "heatmap" },
                        attrs: {
                          type: "button",
                          role: "tab",
                          "aria-selected":
                            _vm.dataVizTab === "heatmap" ? "true" : "false",
                        },
                        on: {
                          click: function ($event) {
                            _vm.dataVizTab = "heatmap"
                          },
                        },
                      },
                      [_vm._v(" Heatmap ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "fbr-data-viz-tab",
                        class: { "is-active": _vm.dataVizTab === "network" },
                        attrs: {
                          type: "button",
                          role: "tab",
                          "aria-selected":
                            _vm.dataVizTab === "network" ? "true" : "false",
                        },
                        on: {
                          click: function ($event) {
                            _vm.dataVizTab = "network"
                          },
                        },
                      },
                      [_vm._v(" Graph network ")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "fbr-data-viz-toolbar-end" },
                  [
                    _vm.showWorkflowSelectionChrome
                      ? _c("workflow-viz-toolbar-menus", {
                          attrs: {
                            "selected-nodes": _vm.selectedNodes,
                            "saved-explanations": _vm.savedExplanations,
                            "saved-dataset-runs": _vm.savedDatasetRuns,
                          },
                          on: {
                            "analyze-explain": function ($event) {
                              return _vm.$emit("analyze-explain")
                            },
                            "analyze-provenance": function ($event) {
                              return _vm.$emit("analyze-provenance")
                            },
                            "open-saved-explanation": function ($event) {
                              return _vm.$emit("open-saved-explanation", $event)
                            },
                            "open-saved-dataset": function ($event) {
                              return _vm.$emit("open-saved-dataset", $event)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              class:
                _vm.useFactorBaseRevealData && _vm.heatmapPairCount
                  ? "fbr-data-viz-panel"
                  : "",
            },
            [
              _vm.showFactorValueColumnFilters
                ? _c(
                    "div",
                    {
                      staticClass: "fbr-data-viz-view-filters",
                      attrs: {
                        role: "group",
                        "aria-label": "Visualization filters",
                      },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "fbr-heatmap-filter-toggle mb-0",
                          class: {
                            "is-locked": _vm.geneSetClustersFilterLocked,
                          },
                          attrs: {
                            title: _vm.geneSetClustersFilterLocked
                              ? "Required on Y-axis for current Render by"
                              : null,
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.geneSetClustersFilterLocked,
                            },
                            domProps: {
                              checked: _vm.effectiveShowGeneSetClusters,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onHeatmapViewFilterChange(
                                  "showGeneSetClusters",
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("Gene set clusters")]),
                        ]
                      ),
                      _c(
                        "label",
                        {
                          staticClass: "fbr-heatmap-filter-toggle mb-0",
                          class: { "is-locked": _vm.geneSetsFilterLocked },
                          attrs: {
                            title: _vm.geneSetsFilterLocked
                              ? "Required on Y-axis for current Render by"
                              : null,
                          },
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.geneSetsFilterLocked,
                            },
                            domProps: { checked: _vm.effectiveShowGeneSets },
                            on: {
                              change: function ($event) {
                                return _vm.onHeatmapViewFilterChange(
                                  "showGeneSets",
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("Gene sets")]),
                        ]
                      ),
                      _c(
                        "label",
                        { staticClass: "fbr-heatmap-filter-toggle mb-0" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: _vm.viewFilters.showGenes },
                            on: {
                              change: function ($event) {
                                return _vm.onHeatmapViewFilterChange(
                                  "showGenes",
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("Genes")]),
                        ]
                      ),
                      _c(
                        "label",
                        { staticClass: "fbr-heatmap-filter-toggle mb-0" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.viewFilters.genesInSearchOnly,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onHeatmapViewFilterChange(
                                  "genesInSearchOnly",
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("Genes in search")]),
                        ]
                      ),
                      _c(
                        "label",
                        { staticClass: "fbr-heatmap-filter-toggle mb-0" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: _vm.viewFilters.onlySelected },
                            on: {
                              change: function ($event) {
                                return _vm.onHeatmapViewFilterChange(
                                  "onlySelected",
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _c("span", [_vm._v("Only selected")]),
                        ]
                      ),
                      _vm.dataVizTab === "heatmap"
                        ? _c(
                            "div",
                            { staticClass: "fbr-heatmap-axis-layout" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "fbr-heatmap-axis-layout-label mb-0",
                                  attrs: {
                                    for: "fbr-heatmap-axis-layout-select",
                                  },
                                },
                                [_vm._v("Render by:")]
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.heatmapAxisLayout,
                                      expression: "heatmapAxisLayout",
                                    },
                                  ],
                                  staticClass:
                                    "form-control form-control-sm fbr-heatmap-axis-layout-select",
                                  attrs: {
                                    id: "fbr-heatmap-axis-layout-select",
                                    "aria-label": "Render heatmap by",
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.heatmapAxisLayout = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "factorsRows" } },
                                    [
                                      _vm._v(
                                        "Gene set clusters × gene sets & genes"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "option",
                                    { attrs: { value: "geneSetsRows" } },
                                    [
                                      _vm._v(
                                        "Gene sets × gene set clusters & genes"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.showFactorValueColumnFilters && _vm.dataVizTab === "heatmap"
                ? _c("div", { staticClass: "viz-legend viz-legend--plain" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "legend-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm btn-outline-secondary d-inline-flex align-items-center",
                          attrs: { type: "button" },
                          on: { click: _vm.downloadHeatmap },
                        },
                        [
                          _c("b-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "download", "aria-hidden": "true" },
                          }),
                          _vm._v(" Heatmap "),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.useFactorBaseRevealData ||
                        _vm.dataVizTab === "heatmap",
                      expression:
                        "!useFactorBaseRevealData || dataVizTab === 'heatmap'",
                    },
                  ],
                  staticClass: "fbr-data-viz-heatmap-pane",
                },
                [
                  !_vm.loading &&
                  _vm.cellColorMode !== "factorValue" &&
                  (_vm.useFactorBaseRevealData
                    ? _vm.heatmapDataFromFactorData &&
                      _vm.heatmapDataFromFactorData.ready
                    : _vm.heatmapData &&
                      _vm.heatmapData.genes &&
                      _vm.heatmapData.genes.length > 0)
                    ? _c("div", { staticClass: "viz-legend" }, [
                        _c("div", { staticClass: "legend-content" }, [
                          _vm.showAssociationLegend
                            ? _c("div", { staticClass: "legend-item" }, [
                                _c("span", { staticClass: "legend-label" }, [
                                  _vm._v("Phenotype associations:"),
                                ]),
                                _c(
                                  "label",
                                  { staticClass: "legend-filter-toggle" },
                                  [
                                    _c("input", {
                                      staticClass:
                                        "legend-filter-checkbox very-strong",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.associationFilters.veryStrong,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onAssociationFilterChange(
                                            "veryStrong",
                                            $event.target.checked
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "legend-color-text" },
                                      [_vm._v("Very Strong (> 3)")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  { staticClass: "legend-filter-toggle" },
                                  [
                                    _c("input", {
                                      staticClass:
                                        "legend-filter-checkbox strongly-suggestive",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.associationFilters
                                            .stronglySuggestive,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onAssociationFilterChange(
                                            "stronglySuggestive",
                                            $event.target.checked
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "legend-color-text" },
                                      [_vm._v("Strongly Suggestive (2-3)")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  { staticClass: "legend-filter-toggle" },
                                  [
                                    _c("input", {
                                      staticClass:
                                        "legend-filter-checkbox nominally-significant",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.associationFilters
                                            .nominallySignificant,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onAssociationFilterChange(
                                            "nominallySignificant",
                                            $event.target.checked
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "legend-color-text" },
                                      [_vm._v("Nominally Significant (1-2)")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  { staticClass: "legend-filter-toggle" },
                                  [
                                    _c("input", {
                                      staticClass:
                                        "legend-filter-checkbox not-significant",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.associationFilters.notSignificant,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onAssociationFilterChange(
                                            "notSignificant",
                                            $event.target.checked
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "legend-color-text" },
                                      [_vm._v("Not Significant (< 1)")]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.emphasizeSearchContextGenes &&
                          _vm.heatmapHasSearchContextGeneColumns
                            ? _c("div", { staticClass: "legend-item mt-1" }, [
                                _c("span", { staticClass: "legend-label" }, [
                                  _vm._v("Gene columns:"),
                                ]),
                                _vm._m(1),
                                _vm._m(2),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "legend-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-outline-secondary d-inline-flex align-items-center",
                              attrs: { type: "button" },
                              on: { click: _vm.downloadHeatmap },
                            },
                            [
                              _c("b-icon", {
                                staticClass: "mr-1",
                                attrs: {
                                  icon: "download",
                                  "aria-hidden": "true",
                                },
                              }),
                              _vm._v(" Heatmap "),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "heatmap-container",
                      attrs: { id: "factor-base-reveal-heatmap-wrapper" },
                    },
                    [
                      _vm.useFactorBaseRevealData &&
                      (!_vm.heatmapDataFromFactorData ||
                        !_vm.heatmapDataFromFactorData.ready)
                        ? _c(
                            "div",
                            { staticClass: "text-center p-3 text-muted" },
                            [
                              !_vm.heatmapPairCount
                                ? [
                                    _vm._v(
                                      "No phenotypes or data categories available to plot."
                                    ),
                                  ]
                                : _vm.effectiveHeatmapGroupMode !== "all" &&
                                  !_vm.selectedHeatmapGroup
                                ? [
                                    _vm._v(
                                      "Select a " +
                                        _vm._s(
                                          _vm.effectiveHeatmapGroupMode ===
                                            "direction"
                                            ? "data category"
                                            : "phenotype"
                                        ) +
                                        "."
                                    ),
                                  ]
                                : _vm.cellColorMode === "factorValue" &&
                                  _vm.viewFilters.onlySelected &&
                                  !(
                                    _vm.selectedNodes &&
                                    _vm.selectedNodes.length
                                  )
                                ? [
                                    _vm._v(
                                      "Select rows or columns to show with Only selected."
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "No matrix data for this selection."
                                    ),
                                  ],
                            ],
                            2
                          )
                        : !_vm.useFactorBaseRevealData &&
                          (!_vm.heatmapData ||
                            !_vm.heatmapData.genes ||
                            _vm.heatmapData.genes.length === 0)
                        ? _c(
                            "div",
                            { staticClass: "text-center p-3 text-muted" },
                            [_vm._v(" Loading heatmap data... ")]
                          )
                        : _c(
                            "div",
                            { staticClass: "heatmap-scrollable-wrapper" },
                            [
                              _c("div", {
                                ref: "heatmapLabelsContainer",
                                staticClass: "heatmap-labels-fixed",
                              }),
                              _c("div", {
                                ref: "heatmapContainer",
                                staticClass: "heatmap-content-scrollable",
                              }),
                            ]
                          ),
                    ]
                  ),
                ]
              ),
              _vm.useFactorBaseRevealData && _vm.dataVizTab === "network"
                ? _c("div", { staticClass: "fbr-data-network-panel" }, [
                    !_vm.heatmapPairCount
                      ? _c(
                          "div",
                          { staticClass: "text-center p-3 text-muted" },
                          [
                            _vm._v(
                              " No phenotypes or data categories available to plot. "
                            ),
                          ]
                        )
                      : _vm.effectiveHeatmapGroupMode !== "all" &&
                        !_vm.selectedHeatmapGroup
                      ? _c(
                          "div",
                          { staticClass: "text-center p-3 text-muted" },
                          [
                            _vm._v(
                              " Select a " +
                                _vm._s(
                                  _vm.effectiveHeatmapGroupMode === "direction"
                                    ? "data category"
                                    : "phenotype"
                                ) +
                                ". "
                            ),
                          ]
                        )
                      : !_vm.dataViewNetwork.nodes.length
                      ? _c(
                          "div",
                          { staticClass: "text-center p-3 text-muted" },
                          [
                            _vm.cellColorMode === "factorValue" &&
                            _vm.viewFilters.onlySelected &&
                            !(_vm.selectedNodes && _vm.selectedNodes.length)
                              ? [
                                  _vm._v(
                                    " Select rows or columns to show with Only selected. "
                                  ),
                                ]
                              : [_vm._v("No network data for this selection.")],
                          ],
                          2
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "fbr-network-viz-wrap",
                            style: {
                              minHeight: _vm.dataViewNetworkHeight + "px",
                            },
                          },
                          [
                            _vm.dataVizNetworkRendering
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "fbr-network-loading-overlay",
                                    attrs: {
                                      role: "status",
                                      "aria-live": "polite",
                                    },
                                  },
                                  [
                                    _c("b-spinner", {
                                      attrs: {
                                        small: "",
                                        type: "grow",
                                        variant: "secondary",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "ml-2 small text-muted" },
                                      [_vm._v("Rendering network…")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("factor-base-reveal-network", {
                              key: _vm.dataViewNetworkKey,
                              attrs: {
                                network: _vm.dataViewNetwork,
                                genes: _vm.dataViewNetworkGenes,
                                height: _vm.dataViewNetworkHeight,
                                "selected-nodes": _vm.selectedNodes,
                                "suppress-selection-highlight":
                                  _vm.cellColorMode === "factorValue" &&
                                  _vm.viewFilters.onlySelected,
                                "gene-node-metric-key":
                                  _vm.cellColorMode === "factorValue"
                                    ? "node_score"
                                    : "combined_score",
                                "gene-set-node-metric-key":
                                  _vm.cellColorMode === "factorValue"
                                    ? "node_score"
                                    : "",
                                "edge-distance-metric-key":
                                  _vm.cellColorMode === "factorValue"
                                    ? "factor_value"
                                    : "",
                                "gene-color-by-gwas-support":
                                  _vm.cellColorMode !== "factorValue",
                                "node-selection-enabled": true,
                              },
                              on: {
                                "update:selectedNodes": function ($event) {
                                  return _vm.$emit(
                                    "update:selectedNodes",
                                    $event
                                  )
                                },
                                "network-ready": _vm.onDataViewNetworkReady,
                              },
                            }),
                          ],
                          1
                        ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [
            _vm._v("Loading visualization..."),
          ])
        : _vm._e(),
      _vm.useFactorBaseRevealData
        ? _c("workflow-heatmap-node-action-menu", {
            attrs: {
              open: _vm.heatmapNodeMenuOpen,
              target: _vm.heatmapNodeMenuTarget,
              "is-selected": _vm.heatmapNodeMenuIsSelected,
              left: _vm.heatmapNodeMenuLeft,
              top: _vm.heatmapNodeMenuTop,
            },
            on: {
              close: _vm.closeHeatmapNodeMenu,
              "toggle-select": _vm.onHeatmapNodeMenuToggle,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "legend-content" }, [
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-color-item" }, [
          _c("span", {
            staticClass: "legend-color factor-relevance",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", { staticClass: "legend-color-text" }, [
            _vm._v("Overall gene set cluster value"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "legend-color-item" }, [
      _c(
        "span",
        { staticClass: "legend-gene-sample legend-gene-sample-search" },
        [_vm._v("GENE")]
      ),
      _c("span", { staticClass: "legend-color-text" }, [
        _vm._v("Search gene (bold)"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "legend-color-item" }, [
      _c(
        "span",
        { staticClass: "legend-gene-sample legend-gene-sample-context" },
        [_vm._v("GENE")]
      ),
      _c("span", { staticClass: "legend-color-text" }, [
        _vm._v("Other genes on gene set cluster"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }